<template>
  <div
    style="mask-size: 100% 100%"
    :style="{
      'mask-image': `url('${maskDataUrl}')`,
      '-webkit-mask-image': `url('${maskDataUrl}')`
    }"
  >
    <ImgComponent
      style="opacity: 0 !important"
      :src="src"
      :fallback="fallback"
      @pictureUrlSelected="(newUrl) => (urlToUse = newUrl)"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { ImgUtils } from './imgUtils';

export default defineComponent({
  name: 'HomeBottomNavs',
  components: {},
  props: {
    src: { type: String, default: '' },
    fallback: { type: String, default: '' }
  },
  data() {
    return {
      urlToUse: this.src
    };
  },
  computed: {
    maskDataUrl() {
      return ImgUtils.normalizeToBase64(this.urlToUse);
    }
  },
  methods: {}
});
</script>
